class RealtimeManager {
    constructor() {
        this.subs = {};
        this.originalData = null;
        this.ref = null;

        this.pending = new Map();
        this.pendingId = null;
        this.pendingAfterCallback = null;
    }

    getOriginalData = () => {
        return this.originalData;
    };

    init = ({ data, ref }) => {
        this.originalData = data ? JSON.parse(JSON.stringify(data)) : null;
        this.ref = ref;

        this.startPending();
    };

    clear = () => {
        this.subs = {};
        this.originalData = null;

        this.pending.clear();

        if (this.pendingId) {
            clearInterval(this.pendingId);
            this.pendingId = null;
        }
    };

    startPending = () => {
        this.pendingId = setInterval(() => {
            if (this.pending.size === 0) {
                return;
            }

            // получаем batch копируя pending (которые накопились за 5 сек)
            const batch = new Map(this.pending);

            // очищаем pending
            this.pending.clear();

            // уведомляем
            for (const [listenEventName, buildValueCallback] of batch.entries()) {
                this.notify(listenEventName, buildValueCallback);
            }
            this.pendingAfterCallback?.();
            this.pendingAfterCallback = null;
        }, 5000);
    };

    subscribe = (listenEventName, callback) => {
        if (!this.subs[listenEventName]) {
            this.subs[listenEventName] = new Set();
        }

        this.subs[listenEventName].add(callback);

        return () => {
            if (this.subs[listenEventName]) {
                this.subs[listenEventName].delete(callback);
            }
        };
    };

    // добавляет в очередь уведомлений (уведомит через 5 секунд)
    pendingNotify = (listenEventName, buildValueCallback, afterUpdateCallback) => {
        this.pending.set(listenEventName, buildValueCallback);
        this.pendingAfterCallback ??= afterUpdateCallback;
    };

    // сразу уведомляет всех подписчиков
    notify = (listenEventName, buildValueCallback) => {
        if (this.subs[listenEventName]) {
            this.subs[listenEventName].forEach((callback) => {
                callback(buildValueCallback);
            });
        }
    };
}

export default new RealtimeManager();
